import React, { useEffect, useState } from "react";

const Fade = ({ show, children, className }) => {
  const [render, setRender] = useState(show);

  useEffect(() => {
    if (show) setRender(true);
  }, [show]);

  const onAnimationEnd = () => {
    if (!show) setRender(false);
  };

  return (
    render && (
      <div
        className={className}
        style={{ animation: `${show ? "fadeIn" : "fadeOut"} 1s forwards` }}
        onAnimationEnd={onAnimationEnd}
      >
        {children}
      </div>
    )
  );
};

export default Fade;
